import { render, staticRenderFns } from "./ListeVente.vue?vue&type=template&id=33c283df"
import script from "./ListeVente.vue?vue&type=script&lang=js"
export * from "./ListeVente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports